export default {
	callback: "Authentication",
	loading: "Loading",
	verifyEmail: "Pending Email Verification",
	signUp: "Sign Up",
	signIn: "Sign In",
	subscriptionConfirmation: "Subscription Confirmation",
	zoomOauthCallback: "Zoom OAuth Success",
};
